import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const Seo = ({title, description, noIndex, keywords, children, ...props}) => {
    const config = getConfig()
    const {threeLetter} = config.app
    const DEFAULT_SITE_TITLE = `${threeLetter} Store`
    const fullTitle = title ? `${title} | ${DEFAULT_SITE_TITLE}` : DEFAULT_SITE_TITLE

    return (
        <Helmet {...props}>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {noIndex && <meta name="robots" content="noindex" />}
            {keywords && <meta name="keywords" content={keywords} />}
            {children}
        </Helmet>
    )
}

Seo.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    noIndex: PropTypes.bool,
    children: PropTypes.node,
    keywords: PropTypes.string
}

export default Seo
